// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__22RNo","errorLogs":"EditorFooter_errorLogs__2mQqt"};